exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".options-popup[data-v-429f6e6e]{position:absolute;z-index:1000;background-color:#fff;border:1px solid #ccc;box-shadow:0 2px 4px rgba(0,0,0,.1);max-height:150px;overflow-y:auto}.options-list[data-v-429f6e6e]{padding:10px}.option-item[data-v-429f6e6e]{padding:5px 10px;cursor:pointer}.option-item[data-v-429f6e6e]:hover{background-color:#f0f0f0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-429f6e6e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/discuss/prac/OptionsPopup.vue
// module id = 1009
// module chunks = 0